import loggerStyle from "../../../../commandLogger.module.css";
import buttonStyle from "../../../../../../../Common/buttons.module.css";
import { Vulnerability } from "../../../../../../../../sdkStructs";
import { Sparkles } from "lucide-react";

interface Props {
  vulns: Vulnerability[];

  generateSections: () => void;
}

function GenerateWidget({ vulns, generateSections }: Readonly<Props>) {
  function getGenerated() {
    let generated = 0;
    vulns.forEach((vuln) => {
      if (vuln.Description !== "") generated++;
    });
    return generated;
  }

  return (
    <div className={loggerStyle.generateInformation}>
      <button className={buttonStyle.button + " " + buttonStyle.fullWidth} onClick={generateSections}>
        <Sparkles className={buttonStyle.iconMargin} stroke="white" strokeWidth="1.5" /> Generate All
      </button>
      <span className={loggerStyle.percentGenerated}>
        {getGenerated()}/{vulns.length}
      </span>

    </div>
  );
}

export default GenerateWidget;
